import { Translation } from 'cng-common/features/translations'

import { ROUND_TABLE_TRANSLATION_KEYS } from '../../configs/translations'

export const RoundTableText = ({ name }: { name: keyof typeof ROUND_TABLE_TRANSLATION_KEYS }) => (
  <Translation span text={ROUND_TABLE_TRANSLATION_KEYS[name]} />
)
